import { useEffect } from 'react';
import { useLanguageFallback } from '@/app/shells/PublicShell';
import { LANGUAGE_FALLBACK } from '@/features/common/languageFallback';
import type { LanguageFallback } from '@/features/common/types/LanguageFallback';

/**
 * Keeps the shell's language notice saying `fallback` while the page is on screen.
 *
 * Its own effect, keyed on the value rather than raised inside a page's fetch: a fetch effect that
 * re-runs (the event page's canonical redirect skips its second run) would lower the notice in its
 * cleanup and never raise it again.
 */
export function usePageLanguageFallback(fallback: LanguageFallback) {
  const setFallback = useLanguageFallback();
  useEffect(() => {
    setFallback(fallback);
  }, [fallback, setFallback]);
  // The notice belongs to this page; left raised it would carry onto the next one.
  useEffect(() => () => setFallback(LANGUAGE_FALLBACK.none), [setFallback]);
}
